import { createFileRoute } from '@tanstack/react-router';
import { ReportSubmitPage } from '@/features/people/public/report-submit-page';

export const Route = createFileRoute('/_public/r/')({
  validateSearch: (search: Record<string, unknown>): { shop?: string } => ({
    shop: typeof search.shop === 'string' && search.shop ? search.shop : undefined,
  }),
  component: ReportRoute,
});

function ReportRoute() {
  const { shop } = Route.useSearch();
  return <ReportSubmitPage shop={shop} />;
}
